export interface ThresholdLevel {
    id: string;
    levelIndex: number;
    minValue: number;
    maxValue: number;
    rewardValue: number;
}

export interface ThresholdScoringPayload {
    contentItemId: number;
    thresholds: ThresholdLevel[];
    maxScore: number;
    minScore: number;
    step: number;
    nrOfDecimals: number;
}

export enum ThresholdScoringMessageTypes {
    OPEN_THRESHOLD_SCORING_OVERLAY = 'author2wrapper:openThresholdScoringOverlay',
    SAVE_THRESHOLD_SCORING = 'author2wrapper:saveThresholdScoring',
    CLOSE_THRESHOLD_SCORING_OVERLAY = 'author2wrapper:closeThresholdScoringOverlay',
}
